module.exports = __webpack_public_path__ + "img/am-banner-presidents.84fb024c.jpg";